import { render } from "./GmailCompose.vue?vue&type=template&id=621093c2&scoped=true"
import script from "./GmailCompose.vue?vue&type=script&lang=js"
export * from "./GmailCompose.vue?vue&type=script&lang=js"

import "./GmailCompose.vue?vue&type=style&index=0&id=621093c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-621093c2"

export default script